import React, {useEffect, useState} from "react";
import logo from "./logo.svg";
import "./App.module.css";

import styled from "styled-components";
import {  withRouter } from "react-router-dom";
import ScrollTop from "./scrolltop";
import get from "lodash/get";
import { connect } from "react-redux";
import {bindActionCreators, compose} from "redux";


import LoadingComponent from "./components/loading/loadingcomponent";
import Routes from "./routes";

import AuthenticationHOC from "./HOC/authenticationHOC";
import {CLR_PRESIGN_URL, env} from "@app/common/config/url-config";
import {ENQUIRY_TEXT} from "./constants/appconstants";
import Typography from "@material-ui/core/Typography";
import IdleTimer from "react-idle-timer";
import {loadSession, loadSessionExpired, setLoading} from "@app/common/store/action";




function App(props) {
  const isLoading = get(props, "loading.isLoading");
  const loadingTitleLabel = get(props, "loading.titleLabel");
  const loadingSubtitleLabel = get(props, "loading.subtitleLabel");
  const isDelay = get(props, "loading.isDelay");
  const loadingStatus = get(props, "loading.status");
  console.log("env",props.history)
  console.log("env",env)

  return (
      <div className="App">
        <Wrapper>
          <ScrollTop location={props}>

            <section className="route-section">
              <LoadingComponent isLoading={isLoading}
                                titleLabel={loadingTitleLabel}
                                subtitleLabel={loadingSubtitleLabel}
                                isDelay={isDelay}
                                status={loadingStatus}/>
              <AuthenticationHOC>
                <Routes/>
                <div className={"app_bottom_container"}>
                  <Typography>
                    {ENQUIRY_TEXT}
                  </Typography>
                </div>
              </AuthenticationHOC>
            </section>
          </ScrollTop>
        </Wrapper>
      </div>
  );
}

const Wrapper = styled.div`
  .fade-enter {
    opacity: 0.01;
  }

  .fade-enter.fade-enter-active {
    opacity: 1;
    transition: opacity 300ms ease-in;
  }

  .fade-exit {
    opacity: 1;
  }

  .fade-exit.fade-exit-active {
    opacity: 0.01;
    transition: opacity 300ms ease-in;
  }
  .app_bottom_container{
    background-color: #063e59;
    color: #FFFFFF;
    padding: 15px;
  }

  div.transition-group {
    position: relative;
  }

  section.route-section {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
  }
`;

const mapStateToProps = (state, ownProps) => ({
  loading: state.loading,
});

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({loadSessionExpired }, dispatch),
  };
}
export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(App);
// export default withRouter(App);
